module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-pl-PL.9ecf3bee.jpg";